query ALL_PRODUCTS {
  allProducts {
    id
    description
    file
    name
    price
    isPromoted
    externalLink
    category {
      name
      id
    }
    allowMultiple
    facility {
      id
      name
    }
  }
}
